import { profile } from "@shared/api/services"
import { useQuery } from "@tanstack/react-query"

export const useTimeSlots = (isTeacher) => {
	return useQuery({
		queryKey: ['time-slots'], 
		enabled: !!isTeacher,
		queryFn: () => profile.getTimeSlots(),
		select: data => data.data
	})
}